import { observable, action, computed } from "mobx";
import { toast } from "react-toastify";
import { IAudioStatus, IAudioEvent } from "../types/IAudio";
import FirebaseDocumentService from "../services/impl/firebase/FirebaseDocumentService";
import IAudioService from "../services/spi/IAudioService";
import AgoraAudioService from "../services/impl/agora/AgoraAudioService";
import IDocumentService from "../services/spi/IDocumentService";

class PresenterControlStore {
  rootStore: any;
  documentService = {} as IDocumentService;
  audioService = {} as IAudioService;
  @observable audioStatus:IAudioStatus = IAudioStatus.NotConnected;
  @observable localAudioLevel:number = 0;
  
  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.documentService = new FirebaseDocumentService();
    this.audioService = AgoraAudioService.getInstance();
    setInterval(() => {
        this.localAudioLevel = this.audioService.getAudioStatus().audioLevel;
    }, 100);
  }

  @action joinAudio = (channel: string, uid: number) => {
    this.audioStatus = IAudioStatus.Connecting;
    this.audioService.connectToRoom(channel, uid,
      (disconnect:IAudioEvent)=>{
        toast.error(disconnect);
      },
      (someoneJoined:IAudioEvent)=>{
        toast.info(someoneJoined);
      },
      (someoneLeft:IAudioEvent)=>{
        toast.info(someoneLeft);
      },
      (muted:IAudioEvent)=>{
        toast.info(muted)
      },
      (unmuted:IAudioEvent)=>{
        toast.info(unmuted)
      }).then((success:any)=>{
        this.audioStatus = IAudioStatus.Connected;
      }, (err:any) =>{
        this.audioStatus = IAudioStatus.NotConnected;
      })
    /*const ref = "/users/" + authUser.uid + "/meetings/" + meeting.uid + "/presenter/audio"
    this.updateAttribute(firebase, ref, "status", "ONLINE") 
    this.updateAttribute(firebase, ref, "optedIn", true);*/
  };

  @action muteAudio = () => {
    this.audioService.mute().then((success:any)=>{
      this.audioStatus = IAudioStatus.Muted
      toast.info("Call Muted");
    })
    /*const ref = "/users/" + authUser.uid + "/meetings/" + meeting.uid + "/presenter/audio"
    this.updateAttribute(firebase, ref, "isMute", true) */
  };

  @action unMuteAudio = () => {
    this.audioService.unmute().then((success:any)=>{
      this.audioStatus = IAudioStatus.Connected;
      toast.info('Call Unmuted')
    })
    /*const ref = "/users/" + authUser.uid + "/meetings/" + meeting.uid + "/presenter/audio"
    this.updateAttribute(firebase, ref, "isMute", false) */
  };

  @action leaveAudio = (channel:string) => {
    this.audioService.disconnectFromRoom(channel).then(()=>{
      this.audioStatus = IAudioStatus.NotConnected;
    })  
  };

  @action onWindowClose = (firebase:any, userId:any, meeting:any) =>{

  }

}

export default PresenterControlStore;
